import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IIdentityState } from './identity.state';

export class IdentitySelectors {
  // todo: replace any type state with root state (once defined)
  static readonly identityState = (state: IRootState): IIdentityState => {
    return state.identity as IIdentityState;
  };

  static readonly model = createSelector(IdentitySelectors.identityState, (identity: IIdentityState) => {
    return identity.model;
  });

  static readonly data = createSelector(IdentitySelectors.identityState, (identity: IIdentityState) => {
    return identity.data;
  });
}
